import { api, responseErrorCheck, TmrBaseResource, ResourcePage, TmrWorkstation } from 'stylewhere/api'

export class Workstations extends TmrBaseResource {
  static readonly endpoint = 'api/v1/workstations' //edge/

  static searchByPlaceId(placeIds, requestConfig = undefined) {
    const data = {
      placeIds
    }
    return api.post(`${this.endpoint}/search?size=500`, data, requestConfig).then(responseErrorCheck)
  }

  static searchByCodes(codes: string[], requestConfig = undefined) {
    const data = {
      equalCodes: codes
    }
    return api.post(`${this.endpoint}/search?size=500`, data, requestConfig).then(responseErrorCheck)
  }

  static filterSearch<TmrWorkstation>(filters: any, requestConfig = undefined): Promise<ResourcePage<TmrWorkstation>> {
    const data = {
      ...filters
    }
    return api.post(`${this.endpoint}/search?size=150`, data, requestConfig).then(responseErrorCheck)
  }
}
